import { WorkerTypeEnum } from 'types'

export const isEmployee = (worker: TWorker): worker is Employee =>
  worker.workerType === WorkerTypeEnum.Employee

export const isContingentWorker = (
  worker: TWorker,
): worker is ContingentWorker =>
  worker.workerType === WorkerTypeEnum.ContingentWorker
